import { render, staticRenderFns } from "./Lideres.vue?vue&type=template&id=53a18ecc&scoped=true"
import script from "./Lideres.vue?vue&type=script&lang=js"
export * from "./Lideres.vue?vue&type=script&lang=js"
import style0 from "./Lideres.vue?vue&type=style&index=0&id=53a18ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a18ecc",
  null
  
)

export default component.exports